import { motion } from "framer-motion";
import { Brain, Clock, Lightbulb } from "lucide-react";
import { ReactNode } from "react";

const problems: { icon: ReactNode; title: string; desc: string }[] = [
  {
    icon: <Lightbulb className="w-10 h-10 text-foreground stroke-[1.5]" />,
    title: "יש לי רעיון תקוע בראש - אבל קשה להסביר אותו.",
    desc: "בראש זה ברור ועל הדף זה לא מסתדר",
  },
  {
    icon: <Clock className="w-10 h-10 text-foreground stroke-[1.5]" />,
    title: "כל שינוי קטן שורף לנו זמן יקר.",
    desc: "במקום סקיצה בשניות נתקעים בסוליד שעות",
  },
  {
    icon: <Brain className="w-10 h-10 text-foreground stroke-[1.5]" />,
    title: "הפטנט ברור בראש ובדף זה מתפזר.",
    desc: "מתקשה להפוך מחשבה להסבר מפורט",
  },
];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0, transition: { duration: 0.45 } },
};

const ProblemSection = () => (
  <section className="px-6 py-16 md:py-24 bg-muted/50" dir="rtl">
    <div className="max-w-3xl mx-auto">
      <div className="text-center mb-10">
         <h2 className="text-foreground text-2xl md:text-3xl font-bold">
           זה נשמע מוכר?
         </h2>
      </div>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.3 }}
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
      >
        {problems.map((p) => (
          <motion.div
            key={p.title}
            variants={item}
            className="bg-card rounded-xl p-6 shadow-sm border border-border text-center"
          >
            <span className="mb-4 flex justify-center">{p.icon}</span>
            <h3 className="text-foreground text-xl font-bold mb-2">{p.title}</h3>
            <p className="text-muted-foreground text-base leading-relaxed">{p.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default ProblemSection;
